var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"login-password-change-prompt"},[_c('div',{staticClass:"password-change-info"},[_vm._v(" "+_vm._s(_vm.$t('general.users.passwordChangeRequired'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }